import { configureStore } from '@reduxjs/toolkit';

import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';

import rootReducer from './reducer';
import { resourcesApi } from '../../resources';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(tjenesteTeksterApi.middleware)
      .concat(additionalPageContentApi.middleware)
      .concat(resourcesApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
